// src/serviceWorkerRegistration.js

// This code registers the service worker in a production environment.
const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname === '127.0.0.1'
  );
  
  export function register(config) {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
      if (publicUrl.origin !== window.location.origin) {
        return;
      }
  
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  
        if (isLocalhost) {
          // Check if the service worker is valid
          checkValidServiceWorker(swUrl, config);
        } else {
          // Register the service worker
          registerValidSW(swUrl, config);
        }
      });
    }
  }
  
  // The code to register the service worker
  function registerValidSW(swUrl, config) {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        console.log('Service Worker registration successful:', registration);
  
        if (config && config.onSuccess) {
          config.onSuccess(registration);
        }
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
  
        if (config && config.onError) {
          config.onError(error);
        }
      });
  }
  
  // This function checks if a valid service worker exists (for localhost).
  function checkValidServiceWorker(swUrl, config) {
    fetch(swUrl)
      .then((response) => {
        // If the service worker file exists, register it.
        if (response.status === 404) {
          // Service worker is not found, unregister it.
          navigator.serviceWorker.ready.then((registration) => {
            registration.unregister();
          });
        } else {
          // Register the service worker.
          registerValidSW(swUrl, config);
        }
      })
      .catch(() => {
        console.log('No internet connection found. App is running in offline mode.');
      });
  }
  